<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2023-04-27 09:11:29
 * @LastEditors: lau
 * @LastEditTime: 2023-05-04 15:57:23
-->
<!-- 车辆扫通道二维码自助进出场 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KPJZECG",
                "channelCode": "222"
            },
            responseCode: {
    "data": {
        "carCode": "粤YABCCC1",
        "carOnChannel": 0,
        "channelCode": "222",
        "channelType": 1,
        "parkCode": "2KPJZECG",
        "parkingCode": "230504160025042092564321",
        "plateColor": 6,
        "plateType": 0
    },
    "message": "业务成功",
    "resultCode": 0,
    "status": 1
},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台，检查通道是否有车(可协助开关闸，自助进出场使用)",
                t_url: this.commonUrls.test+"checkChannelExistCar",
                p_url: this.commonUrls.prod+"checkChannelExistCar",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'channelCode', info2: '是', info3: 'String', info4: '通道自定义编码' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'channelCode', info2: '是', info3: 'String', info4: '通道编码' },
                        { info1: 'channelType', info2: '是', info3: 'Integer', info4: '通道类型，0：未确认，1：进口，2：出口' },
                        { info1: 'carOnChannel ', info2: '否', info3: 'Integer', info4: '地感判断是否有车：0无车，1有车,ps:若用视频流，请忽略此信息，第三方可根据车牌号码来判断是否有车，若有车牌号码，可以认为通道上有车，若无车牌号码，则可认为通道无车。' },
                        { info1: 'plateType', info2: '否', info3: 'Integer', info4: '车牌类型，0 有牌车、1无牌车' },
                        { info1: 'carCode', info2: '否', info3: 'Integer', info4: '车牌号码' },
                        { info1: 'plateColor', info2: '否', info3: 'String', info4: '车牌颜色1蓝色，2黄色，3白色，4黑色，5绿色（默认1蓝色）' },
                        { info1: 'parkingCode', info2: '否', info3: 'String', info4: '停车流水号' },
                  
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/checkChannelExistCar.vue